import React, { useState, useRef, useEffect } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './Event_Gallery.css';


import wedding_1 from '../../images/wedding_1.jpg'
import wedding_2 from '../../images/wedding_2.jpg'
import wedding_3 from '../../images/wedding_3.jpg'
import wedding_4 from '../../images/wedding_4.jpeg'
import wedding_5 from '../../images/wedding_5.jpeg'
import wedding_6 from '../../images/wedding_6.jpeg'
import wedding_7 from '../../images/wedding_7.jpeg'
import wedding_8 from '../../images/wedding_8.jpeg'
import wedding_9 from '../../images/wedding_9.jpeg'
import wedding_10 from '../../images/wedding_10.jpeg'
import wedding_11 from '../../images/wedding_11.jpeg'
import wedding_12 from '../../images/wedding_12.jpeg'
import wedding_13 from '../../images/wedding_13.jpeg'
import wedding_14 from '../../images/wedding_14.jpeg'
import wedding_15 from '../../images/wedding_15.jpeg'

import engagement_1 from '../../images/engage_1.jpg'
import engagement_2 from '../../images/engage_2.jpg'
import engagement_3 from '../../images/engage_3.jpg'
import engagement_4 from '../../images/engage_4.jpg'
import engagement_5 from '../../images/engage_5.jpg'
import engagement_6 from '../../images/engage_6.jpg'
import engagement_7 from '../../images/engage_7.jpg'
import engagement_8 from '../../images/engage_8.jpg'
import engagement_9 from '../../images/engage_9.jpg'
import engagement_10 from '../../images/engage_10.jpg'
import engagement_11 from '../../images/engage_11.jpg'
import engagement_12 from '../../images/engage_12.jpg'
import engagement_13 from '../../images/engage_13.jpg'
import engagement_14 from '../../images/engage_14.jpg'
import engagement_15 from '../../images/engage_15.jpg'

import Haldi_1 from '../../images/haldi_1.avif';
import Haldi_2 from '../../images/haldi_2.avif';
import Haldi_3 from '../../images/haldi_3.webp';
import Haldi_4 from '../../images/haldi_4.webp';
import Haldi_5 from '../../images/haldi_5.jpg';
import Haldi_6 from '../../images/haldi_6.jpg';
import Haldi_7 from '../../images/haldi_7.jpg';
import Haldi_8 from '../../images/haldi_8.jpg';
import Haldi_9 from '../../images/haldi_9.jpg';
import Haldi_10 from '../../images/haldi_10.jpg';
import Haldi_11 from '../../images/haldi_11.jpg';
import Haldi_12 from '../../images/haldi_12.jpg';
import Haldi_13 from '../../images/haldi_13.jpg';
import Haldi_14 from '../../images/haldi_14.jpg';
import Haldi_15 from '../../images/haldi_15.jpg';

import birth_1 from '../../images/birth_1.webp';
import birth_2 from '../../images/birth_2.webp';
import birth_3 from '../../images/birth_3.jpg';


const CarouselGallery = () => {
    const [selectedCategory, setSelectedCategory] = useState('wedding');
    const [isLoading, setIsLoading] = useState(true);
    const galleryRef = useRef(null);
    const sliderRef = useRef(null);

    // Set loading state when images are loaded
    useEffect(() => {
        setIsLoading(false);
    }, [selectedCategory]);

    const images = {
        wedding: [
            { id: 1, src: wedding_1, alt: 'Wedding 1' },
            { id: 2, src: wedding_2, alt: 'Wedding 2' },
            { id: 3, src: wedding_3, alt: 'Wedding 3' },
            { id: 4, src: wedding_4, alt: 'Wedding 4' },
            { id: 5, src: wedding_5, alt: 'Wedding 5' },
            { id: 6, src: wedding_6, alt: 'Wedding 6' },
            { id: 7, src: wedding_7, alt: 'Wedding 7' },
            { id: 8, src: wedding_8, alt: 'Wedding 8' },
            { id: 9, src: wedding_9, alt: 'Wedding 9' },
            { id: 10, src: wedding_10, alt: 'Wedding 10' },
            { id: 11, src: wedding_11, alt: 'Wedding 11' },
            { id: 12, src: wedding_12, alt: 'Wedding 12' },
            { id: 13, src: wedding_13, alt: 'Wedding 13' },
            { id: 14, src: wedding_14, alt: 'Wedding 14' },
            { id: 15, src: wedding_15, alt: 'Wedding 15' },
        ],
        engagement: [
            { id: 1, src: engagement_1, alt: 'Engagement 1' },
            { id: 2, src: engagement_2, alt: 'Engagement 2' },
            { id: 3, src: engagement_3, alt: 'Engagement 3' },
            { id: 4, src: engagement_4, alt: 'Engagement 4' },
            { id: 5, src: engagement_5, alt: 'Engagement 5' },
            { id: 6, src: engagement_6, alt: 'Engagement 6' },
            { id: 7, src: engagement_7, alt: 'Engagement 7' },
            { id: 8, src: engagement_8, alt: 'Engagement 8' },
            { id: 9, src: engagement_9, alt: 'Engagement 9' },
            { id: 10, src: engagement_10, alt: 'Engagement 10' },
            { id: 11, src: engagement_11, alt: 'Engagement 11' },
            { id: 12, src: engagement_12, alt: 'Engagement 12' },
            { id: 13, src: engagement_13, alt: 'Engagement 13' },
            { id: 14, src: engagement_14, alt: 'Engagement 14' },
            { id: 15, src: engagement_15, alt: 'Engagement 15' },
        ],
        haldi: [
            { id: 1, src: Haldi_1, alt: 'Haldi 1' },
            { id: 2, src: Haldi_2, alt: 'Haldi 2' },
            { id: 3, src: Haldi_3, alt: 'Haldi 3' },
            { id: 4, src: Haldi_4, alt: 'Haldi 4' },
            { id: 5, src: Haldi_5, alt: 'Haldi 5' },
            { id: 6, src: Haldi_6, alt: 'Haldi 6' },
            { id: 7, src: Haldi_7, alt: 'Haldi 7' },
            { id: 8, src: Haldi_8, alt: 'Haldi 8' },
            { id: 9, src: Haldi_9, alt: 'Haldi 9' },
            { id: 10, src: Haldi_10, alt: 'Haldi 10' },
            { id: 11, src: Haldi_11, alt: 'Haldi 11' },
            { id: 12, src: Haldi_12, alt: 'Haldi 12' },
            { id: 13, src: Haldi_13, alt: 'Haldi 13' },
            { id: 14, src: Haldi_14, alt: 'Haldi 14' },
            { id: 15, src: Haldi_15, alt: 'Haldi 15' },
        ],
        birthday: [
            { id: 1, src: birth_1, alt: 'Birthday 1' },
            { id: 2, src: birth_2, alt: 'Birthday 2' },
            { id: 3, src: birth_3, alt: 'Birthday 3' },
        ],
    };

    const settings = {
        dots: true,
        infinite: true,
        speed: 700,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        fade: true,
        cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
        pauseOnHover: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplaySpeed: 2500,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplaySpeed: 2000,
                }
            }
        ]
    };

    const handleCategoryChange = (category) => {
        setIsLoading(true);
        setSelectedCategory(category);

        // Reset slider to first slide when changing categories
        if (sliderRef.current) {
            sliderRef.current.slickGoTo(0);
        }

        // Scroll to the top of the gallery
        if (galleryRef.current) {
            galleryRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <div className="eg-event-gallery-container">
            <div className="eg-carousel-gallery" ref={galleryRef}>
                <h2 className="eg-gallery-title">Event Gallery</h2>
                <p className="eg-gallery-subtitle">Browse our collection of beautiful events hosted at our venue</p>

                <Slider ref={sliderRef} {...settings}>
                    {images[selectedCategory].map((image) => (
                        <div key={image.id} className="eg-carousel-slide">
                            <div className="eg-image-container">
                                {isLoading && (
                                    <div className="eg-loading-indicator">
                                        <div className="eg-loading-spinner"></div>
                                    </div>
                                )}
                                <img
                                    src={image.src}
                                    alt={image.alt}
                                    className="eg-carousel-image"
                                    loading="lazy"
                                    onLoad={() => setIsLoading(false)}
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        setIsLoading(false);
                                    }}
                                />
                            </div>
                        </div>
                    ))}
                </Slider>

                <div className="eg-category-section">
                    <h3 className="eg-section-title">Browse By Category</h3>
                    <div className="eg-category-buttons">
                        <div className="eg-category-grid">
                            <div className="eg-category-item">
                                <button
                                    className={`eg-btncard ${selectedCategory === 'wedding' ? 'eg-active' : ''}`}
                                    onClick={() => handleCategoryChange('wedding')}
                                >
                                    <img src="https://www.thewedcafe.com/wp-content/uploads/2020/05/09-PRD_0113-Edit.jpg" alt="Wedding" />
                                    <h5>Wedding</h5>
                                </button>
                            </div>

                            <div className="eg-category-item">
                                <button
                                    className={`eg-btncard ${selectedCategory === 'engagement' ? 'eg-active' : ''}`}
                                    onClick={() => handleCategoryChange('engagement')}
                                >
                                    <img src="https://kamatharjun.b-cdn.net/wp-content/uploads/2023/03/South-Indian-wedding-photography-PA-123.jpg" alt="Engagement" />
                                    <h5>Engagement</h5>
                                </button>
                            </div>

                            <div className="eg-category-item">
                                <button
                                    className={`eg-btncard ${selectedCategory === 'haldi' ? 'eg-active' : ''}`}
                                    onClick={() => handleCategoryChange('haldi')}
                                >
                                    <img src="https://media.assettype.com/saamtv%2F2023-09%2F7423374b-9fd8-4dc5-9fb5-69aa2c82e620%2FAkshara_And_Adhipati_Haldi_Photos.jpg" alt="Haldi" />
                                    <h5>Haldi</h5>
                                </button>
                            </div>

                            <div className="eg-category-item">
                                <button
                                    className={`eg-btncard ${selectedCategory === 'birthday' ? 'eg-active' : ''}`}
                                    onClick={() => handleCategoryChange('birthday')}
                                >
                                    <img src="https://st5.depositphotos.com/1662991/68827/i/450/depositphotos_688273316-stock-photo-happy-young-woman-blowing-her.jpg" alt="Birthday" />
                                    <h5>Birthday</h5>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CarouselGallery;